// extracted by mini-css-extract-plugin
export default {"root":"style_root__Aqiz7","tips":"style_tips__2E0bu"};